// extracted by mini-css-extract-plugin
export default {"legend":"chartLegend__legend___e33w3","line":"chartLegend__line___WqEiu","axisLabel":"chartLegend__axisLabel___Kw7eY","additionalValue":"chartLegend__additionalValue___FkA+M"};